import type { TaxCodeFilterOptionsQueryParams } from './useQueryTaxCodeFilterOptions';
import type { TaxCodesQueryParams } from './useQueryTaxCodes';

import type { UUID } from '~/types/common';

/**
 * Query key factory for tax-code queries.
 */
export const queryKeysTaxCode = {
  base: () => ['taxCode'] as const,
  filterOptions: (queryParams?: Partial<TaxCodeFilterOptionsQueryParams>) =>
    [
      ...queryKeysTaxCode.base(),
      'filterOptions',
      ...(queryParams ? [queryParams] : []),
    ] as const,
  get: (taxCodeId: UUID) =>
    [...queryKeysTaxCode.base(), 'detail', { taxCodeId }] as const,
  getAll: (queryParams?: Partial<TaxCodesQueryParams>) =>
    [
      ...queryKeysTaxCode.base(),
      'list',
      ...(queryParams ? [queryParams] : []),
    ] as const,
} as const;
